























import Vue from 'vue';
import VueSelect from 'vue-select';
import { Getter, Mutation, State } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';
import GlobalBus from '@/plugins/GlobalBus';
import { languagesPack } from '@/heplers';
import { GlobalBusNames, StoreMutations } from '@/templates/DataNames';
import { LanguagesPack, SelectedLanguagesPack } from '@/store/types';

// @ts-expect-error: Type 'VueSelectConstructor' is not assignable to type 'Component<any, any, any, any> | AsyncComponent<any, any, any, any>'
@Component({
  components: { VueSelect },
})
export default class LanguageSelector extends Vue {
  @Prop({ default: 40 }) breadcrumbHeight: number;
  @Prop() sdkName: keyof LanguagesPack;
  @Prop({ default: false }) isOverflow: boolean;
  @Prop({
    type: Array,
    default: (): string[] => [],
  })
  tutorialLangs: string[];
  @Mutation(StoreMutations.UPDATE_LANGUAGES_PACK) updateLanguagesPack: (
    langObject: string | { lang: string; activeSdk: string }
  ) => void;
  @Mutation(StoreMutations.SET_CURRENT_LANG) setLang: (lang: string) => void;
  @Mutation(StoreMutations.SET_LANGUAGES) mutateAllLanguages: (languages: any) => void;
  @Getter('getSelectedLanguagesPack') languagesPack: SelectedLanguagesPack;
  @State('selectedLanguagesPack') selectedLanguagesPack: SelectedLanguagesPack;
  @State('pageRendered') pageRendered: boolean;
  @State selectedLang: string;

  public currentLang = '';
  public languagesPackLoaded = false;
  public languageTabs: string[] = [];
  public enabledLanguages: string[] = [];
  private activeCodeTab = 1;
  private OpenIndicator: any = {
    render: (createElement: (arg0: any, arg1: any) => void) =>
      createElement('span', { class: { 'toggle-select': true } }),
  };

  get computedCurrentLang() {
    return this.transformLangValue(this.currentLang);
  }

  get computeClass() {
    return this.isCodeRails
      ? ['is-code-rails', 'is-language-selector', { 'is-scrollbar': this.isOverflow }]
      : 'is-breadcrumbs';
  }

  get isCodeRails(): boolean {
    return this.tutorialLangs.length > 0;
  }

  get hasSingleTab(): boolean {
    return this.languageTabs.length == 1;
  }

  @Watch('pageRendered')
  onPageRenderedChanged(val: boolean) {
    // Меняем только для десктопа, потомушо для мобилки они рендерятся
    if (val && document.body.clientWidth > 1024) {
      this.languagesPackLoaded = false;
      if (!this.isCodeRails)
        GlobalBus.on(GlobalBusNames.CHECKENABLEDLANGS, this.computeEnabledLangs);
      this.initLangs();
    }
  }

  @Watch('sdkName')
  onSdkNameChanged(): void {
    this.languagesPackLoaded = false;

    this.initLangs(true);
  }

  beforeDestroy() {
    GlobalBus.off(GlobalBusNames.CHANGELANGUAGE);
    GlobalBus.off(GlobalBusNames.CHECKENABLEDLANGS);
  }

  mounted() {
    GlobalBus.on(GlobalBusNames.CHANGELANGUAGE, (_uniqId) =>
      this.$nextTick(() => this.initLangs(true))
    );

    this.initLangs();
  }

  checkDisabledLang(lang: string): boolean {
    return this.enabledLanguages.includes(lang);
  }

  transformLangValue(value: string): string {
    if (!value) return '';

    if (value === 'csharp') return 'C#';

    return value === 'nodejs' ? 'NODE.JS' : value.toUpperCase();
  }

  computeEnabledLangs(langs: string[]) {
    if (this.languageTabs.length === langs.length) return;

    this.enabledLanguages = langs.map((lang: string) => this.transformLangValue(lang));

    if (!this.enabledLanguages.includes(this.transformLangValue(this.currentLang))) {
      this.setLanguage(this.enabledLanguages[0], true);
    }
  }

  /**
   * Set active tab
   */
  setActiveTab(index: number): void {
    this.activeCodeTab = index;
    this.currentLang = this.languageTabs[index];
    this.$emit('setCurrentLang', this.currentLang);
    this.updateLanguagesPack({
      lang: this.languageTabs[index],
      activeSdk: this.sdkName,
    });
  }

  /**
   * Set language if user change it from select/input
   */
  setLanguage(value: string, fromEnabledLanguages?: boolean): void {
    this.currentLang = value;
    this.updateLanguagesPack({
      lang: value,
      activeSdk: this.sdkName,
    });

    if (!fromEnabledLanguages) GlobalBus.emit(GlobalBusNames.CHANGELANGUAGE);
    else this.checkActiveTab(this.transformLangValue(value));
  }

  private initLangs(fromChangeSdk = false): void {
    if (!this.sdkName) return;

    this.takeLangsFromStore();
    this.computeLanguageTabs();
    this.setCurrentValue(fromChangeSdk);
    GlobalBus.emit(GlobalBusNames.NEWLANGUAGEPACKLOADED);
  }

  private setCurrentValue(fromChangeSdk: boolean): void {
    const value: any = this.languagesPack[this.sdkName];
    const titleValue = this.transformLangValue(value);

    if (value === this.currentLang) return;

    // Если есть значение в доступных, то меняем на него, иначе если пришли не с mounted то меняем значение на первое доступное
    if (this.languageTabs.includes(titleValue)) {
      this.currentLang = value;
      this.setLang(value);
    } else {
      this.currentLang = this.languageTabs[0];

      if (fromChangeSdk) return;

      this.updateLanguagesPack({
        lang: this.languageTabs[0],
        activeSdk: this.sdkName,
      });
    }

    this.$emit('setCurrentLang', this.currentLang);

    this.checkActiveTab(titleValue);
  }

  /**
   * Set active tab
   */
  private checkActiveTab(value: string): void {
    this.activeCodeTab = this.languageTabs.indexOf(value);
    if (this.activeCodeTab === -1 && !this.isCodeRails) {
      this.setActiveTab(0);
    }
  }

  /**
   * Take langs from store and set it to Vuex
   */
  private takeLangsFromStore(): void {
    if (!localStorage.getItem('selectedLangs')) return;

    let selectedLangs: { [key: string]: string } = JSON.parse(
      localStorage.getItem('selectedLangs')
    );
    this.mutateAllLanguages(selectedLangs);
  }

  private setLanguageTabs(langsArray: string[]) {
    this.languageTabs = langsArray.map((value: string) => this.transformLangValue(value));

    // Проверяем если были, то проверяем что они схожи с languagesTabs, т.е. не с другого sdk сохранились, если схожи, то оставляем, иначе переписываем
    if (this.enabledLanguages.length) {
      let [tabsString, enabledLangsString] = [
        this.languageTabs.join('.'),
        this.enabledLanguages.join('.'),
      ];

      if (!tabsString.includes(enabledLangsString)) this.enabledLanguages = this.languageTabs;
    } else this.enabledLanguages = this.languageTabs;
  }

  /**
   * If we got langs from BlogPages we just use it, else we are take langs from const variables with available langs
   */
  private computeLanguageTabs(): void {
    if (this.isCodeRails) this.setLanguageTabs(this.tutorialLangs);
    else {
      let approvedLangs: string[] = Object.keys(languagesPack[this.sdkName]).filter(
        //@ts-expect-error: Element implicitly has an 'any' type because expression of type 'string' can't be used to index
        (value) => languagesPack[this.sdkName][value] === 'true'
      );

      if (approvedLangs.length > 1) this.setLanguageTabs(approvedLangs);
    }
    this.languagesPackLoaded = true;
  }
}
